var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBalanceReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1959 15.635C30.2873 13.5542 28.7914 11.7837 26.8916 10.5403C24.9917 9.29698 22.7705 8.63484 20.4999 8.63504C14.4508 8.63504 9.47493 13.2399 8.8916 19.135",
    stroke: "#00ED76",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5002 15.6351H31.4668C31.5588 15.6351 31.6498 15.6169 31.7347 15.5818C31.8196 15.5466 31.8968 15.495 31.9618 15.43C32.0268 15.365 32.0784 15.2879 32.1135 15.2029C32.1487 15.118 32.1668 15.027 32.1668 14.9351V10.9684M9.86133 24.9684C11.6627 29.089 15.774 31.9684 20.5573 31.9684C26.6077 31.9684 31.5823 27.3635 32.1668 21.4684",
    stroke: "#00ED76",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5583 24.9684H9.5916C9.40595 24.9684 9.2279 25.0421 9.09663 25.1734C8.96535 25.3047 8.8916 25.4827 8.8916 25.6684V29.635M14.6666 20.3017L20.4999 28.4684L26.3333 20.3017M14.6666 20.3017L20.4999 12.135M14.6666 20.3017L20.4999 21.4684M26.3333 20.3017L20.4999 12.135M26.3333 20.3017L20.4999 21.4684M20.4999 12.135V21.4684",
    stroke: "#00ED76",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBalanceReport);
export default __webpack_public_path__ + "static/media/icon-balance-report.b9da257f.svg";
export { ForwardRef as ReactComponent };